// Shared name-formatting helpers that enforce Allure's privacy display rules.
// Used on the Register page and the Google "complete profile" step so chat
// names always look consistent (e.g. "Maria Kp.").

// First name: keep letters/hyphen/apostrophe ONLY. Spaces are stripped so
// users can't accidentally type "  John" or "John Doe" into the first-name
// field — the privacy display ("Firstname L.") relies on single-token first
// names. Capitalises the first letter.
export const formatFirstName = (value) => {
  const cleaned = (value || '').replace(/[^A-Za-z'-]/g, '').slice(0, 32);
  return cleaned ? cleaned.charAt(0).toUpperCase() + cleaned.slice(1) : '';
};

// Privacy last name: keep at most 1 letter (per GDPR display rule
// "Firstname L."), capitalised. The dot is appended live in the UI and on
// the backend — it's never stored in the value itself.
export const formatLastLetters = (value) => {
  const letters = (value || '').replace(/[^A-Za-z]/g, '').slice(0, 1);
  return letters ? letters.charAt(0).toUpperCase() : '';
};
